import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { DropDown } from "@/components/common";
import { statusData, privacyLevelData } from "@/helpers";
import _ from "lodash";

const AddFormMetaSection = ({
  testId,
  name,
  status,
  is_public,
  accessLevel,
  userRole,
  description,
  email_displayed,
  email_required,
  handleChange,
  handleOnChangeSelect,
  switchBtnColor,
  handleEmailDisplayed,
  handleEmailRequired,
}) => {
  const shared = is_public?.toLowerCase() === "shared";

  return (
    <>
      <Row className="mx-3 gx-5">
        <Col
          xs={12}
          sm={12}
          lg={shared ? 6 : 4}
          xl={shared ? 3 : 4}
          className="mt-4"
        >
          <label className="itemText lable mt-2 C-dark form-label">Name*</label>
          <input
            name="name"
            value={name}
            maxLength={100}
            autoComplete="off"
            lableclass="mb-0 mt-2"
            onChange={handleChange}
            placeholder="Enter Name"
            className="add-form-input p-2"
            id={`${testId}.textInput.name`}
          />
        </Col>
        <Col
          xs={12}
          sm={12}
          lg={shared ? 6 : 4}
          xl={shared ? 3 : 4}
          className="mt-4"
        >
          <label className="itemText lable mt-2 C-dark form-label">Status*</label>
          <DropDown
            noShadow
            name="status"
            value={_.capitalize(status)}
            data={statusData}
            placeholder="Choose Status"
            onChange={handleOnChangeSelect}
            style={{
              height: "35px",
            }}
            toggleId={`${testId}.dropDown.status`}
          />
        </Col>
        <Col
          xs={12}
          sm={12}
          lg={shared ? 6 : 4}
          xl={shared ? 3 : 4}
          className="mt-4"
        >
          <label className="itemText lable mt-2 C-dark form-label">
            Privacy Level*
          </label>
          <DropDown
            noShadow
            name="is_public"
            value={_.capitalize(is_public)}
            data={privacyLevelData}
            placeholder="Choose Privacy Level"
            onChange={handleOnChangeSelect}
            style={{
              height: "35px",
            }}
            toggleId={`${testId}.dropDown.privacy`}
          />
        </Col>
        {shared ? (
          <Col xs={12} sm={12} lg={6} xl={3} className="mt-4">
            <label className="itemText lable mt-2 C-dark form-label">
              Access Level*
            </label>
            <DropDown
              noShadow
              name="accessLevel"
              value={_.capitalize(
                userRole?.find((item) => item.id === accessLevel)?.name
              )}
              data={userRole}
              placeholder="Choose Access Level"
              onChange={handleOnChangeSelect}
              style={{
                height: "35px",
              }}
            />
          </Col>
        ) : null}
      </Row>
      <Row className="my-lg-3 my-sm-3 mx-4">
        <Col xs={12} sm={12} lg={12}>
          <label className="itemText lable mt-2 C-dark form-label">
            Description
          </label>
          <Form.Control
            rows={4}
            as="textarea"
            name="description"
            value={description}
            onChange={handleChange}
            maxLength={500}
            style={{ fontSize: "13px" }}
            placeholder="Enter Description"
            className="form-controls"
            id={`${testId}.textArea.description`}
          />
        </Col>
      </Row>
      <Row className="m-3 mx-4">
        <Col xs={6} lg={4} className="d-flex align-items-center">
          <label className="itemText lable C-dark form-label me-5">
            Email Displayed
          </label>
          <div>
            <input
              id="switch-email-displayed"
              name="email_displayed"
              type="checkbox"
              value={email_displayed}
              checked={email_displayed}
              onChange={handleChange}
              className="switch-checkbox"
            />
            <button
              type="button"
              className="switch-label"
              onClick={(e) => {
                e.preventDefault();
                handleEmailDisplayed();
              }}
            >
              <span
                className={`switch-button ${switchBtnColor(email_displayed)}`}
              />
            </button>
          </div>
        </Col>
        <Col xs={6} lg={4} className="d-flex align-items-center">
          <label className="itemText lable C-dark form-label me-5">
            Email Required
          </label>
          <div>
            <input
              id="switch-email-required"
              name="email_required"
              type="checkbox"
              value={email_required}
              checked={email_required}
              onChange={handleChange}
              className="switch-checkbox"
            />
            <button
              type="button"
              className="switch-label"
              onClick={(e) => {
                e.preventDefault();
                handleEmailRequired();
              }}
            >
              <span
                className={`switch-button ${switchBtnColor(email_required)}`}
              />
            </button>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default AddFormMetaSection;
